import { AlertInfoIcon, HbTooltip, HStack, Text } from '@cdl/heartbeat-react';

export const EffortHeader = () => {
  return (
    <HStack>
      <Text>Effort</Text>
      <HbTooltip
        label={'Hours of work per day and per annotator on average this week'}
      >
        <span>
          <AlertInfoIcon />
        </span>
      </HbTooltip>
    </HStack>
  );
};
